
export const constChannel = {
  WEB: 'web',
  WAP: 'wap',
  // STORE: 'Store',
};
export const constBrand = {
  LP: 'LP',
  PB: 'PB',
  WS: 'WS',
  GAP: 'GAP',
  PBK: 'PBK',
  WLM: 'WLM',
  TRU: 'TRU',
};

export const KAMPYLE_FORM_CODES = {
  LP: 13778,
  PB: 23872,
  WS: 23881,
  GAP: 23871,
  PBK: 23875,
  WLM: 23878,
  TRU: 40097,
};

export const constAccestURL = {
  LP: 'LP',
  PB: 'PB',
  WS: 'WS',
};

export const constEventStatus = {
  ACTIVE: 'Activo', // English Name : Spanish Name
  DELETED: 'Eliminado',
  SUSPENDEDFORTIME: 'Suspendido por Tiempo',
  SUSPENDED: 'Suspendido',
  CLOSED: 'Cerrado',
  VALIDITYOFFACTIVE: 'Evento Extemporaneo',
  ADMINPROCESS: 'Proceso Administrativo',
  DELETEDBYFRAUD: 'Eliminado por Fraude',
  TEMPORARYCLOSED: 'Cierre Temporal',
  NEW_ACTIVE: "ACTIVE",
  UNDER_REVIEW:"Bajo Revisión"
};

export const eventStatus = {
  ACTIVE: 'Activo',
  SUSPENDED: 'Suspendido',
  DELETED: 'Eliminado',
  ADMINISTRATIVE_PROCESS: 'Proceso Administrativo',
  DELETED_BY_FRAUD: 'Eliminado por Fraude',
  VALIDITY_OFF_ACTIVE: 'Evento Extemporaneo',
  CLOSED: 'Cerrado',
  TEMPORARY_CLOSED: 'Cierre Temporal',
  SUSPENDED_FOR_TIME: 'Suspendido por Tiempo',
  UNDER_REVIEW:"Bajo Revisión"
};

export const eventCategory = {
  OPENEVENT: 'Para Toda Ocasión',
  CELEBRATION: 'Para el Gran Día',
};

export const ownerLabel = {
  Celebrated: 'festejado',
  Organizer: 'organizador',
  Administrator: 'administrador',
  CoAdministrator: 'co-administrador',
};

export const eventType = {
  Baptism: 'Bautizo',
  Bar_Mitzvah: 'Bar Mitzvah',
  Bat_Mitzvah: 'Bat Mitzvah',
  Bebe: 'Bebé',
  Boda: 'Boda',
  Confirmacion: 'Confirmación',
  First_Communion: 'Primera Comunión',
  Other_Religious_Ceremonies: 'Otras Ceremonias Religiosas',
  XV_Anos: 'XV años',
  Aniversario: 'Aniversario',
  Cumpleanos: 'Cumpleaños',
  Despedida: 'Despedida',
  Fiesta_Infantil: 'Fiesta Infantil',
  Fiesta_Reunion: 'Fiesta/ Reunión',
  Open_House: 'Open House',
  Others: 'Otros',
  Mascotas: 'Mascotas',
};

export const constAPISuccess = 'success';
export const constAPIFailure = 'failure';
export const constUndefined = 'undefined';
export const constPrint = 'print';
export const constDownload = 'download';
export const constSendMail = 'sendmail';
export const constCookieDomainName = '.liverpool.com.mx';
export const CATEGORIES_LABEL = 'Categorías';

export const UIBrands = [
  { id: 'LP', label: 'Liverpool' },
  { id: 'WS', label: 'Williams-Sonoma' },
  { id: 'WLM', label: 'West Elm' },
  { id: 'PB', label: 'Pottery Barn' },
  { id: 'GAP', label: 'GAP' },
  { id: 'PBK', label: 'Pottery Barn Kids' },
  { id: 'TRU', label: 'Toys r us' },
];

export const UIBrands2 = [
  { id: 'LP', label: 'Liverpool' },
  { id: 'WLM', label: 'West Elm' },
  { id: 'WS', label: 'William Sonoma' },
  { id: 'GAP', label: 'GAP' },
  { id: 'TRU', label: 'ToysRus' },
  { id: 'PBK', label: 'Pottery Barn Kids' },
  { id: 'PB', label: 'Pottery Barn' },
];

export const constGiftDeliveryMode = {
  Físicos: 'physical',
  Electrónicos: 'electronic',
};


export const gmailIntegration = {
  url: 'https://people.googleapis.com/v1/people/me/connections?',
  connections: 'personFields=emailAddresses%2Cnames%2Cphotos%2CphoneNumbers&fields=connections(emailAddresses%2Cnames%2CphoneNumbers%2Cphotos%2CresourceName)&key=',
};

export const grServicePriFix = '/regalos/services';
export const ecomServicePriFix = '/public/v1';
export const showLabelTextQueryString = 'showkey';

export const facebookAppId = '237527333469985';


export const activeSites = ["liverpool.com.mx", "potterybarnkids.com.mx", "gap.com.mx", "westelm.com.mx", "williams-sonoma.com.mx", "suburbia.com.mx","toysrus.com.mx"];


export const retreiveSiteSpecificSSLCert = (hostname,brandname) => {
  let envv = {"key": "TLS_KEY", "cert":'TLS_CERT', "ca": 'TLS_CA'};
  if(hostname !== "liverpool.com.mx")
  {
    envv = { "key": brandname+"_TLS_KEY", "cert": brandname+'_TLS_CERT', "ca":brandname+'_TLS_CA' };
  }
  return envv;
}; 

// export const gmailIntegration = {
//   // urlKey: 'AIzaSyBZpLgYiuZoglVZMIckIEuI924lGGoDM2I',
//   gmailUrl: 'https://people.googleapis.com/v1/people/me/connections?personFields=emailAddresses%2Cnames%2Cphotos%2CphoneNumbers&fields=connections(emailAddresses%2Cnames%2CphoneNumbers%2Cphotos%2CresourceName)&key=AIzaSyBZpLgYiuZoglVZMIckIEuI924lGGoDM2I',
// };


export const mappingEventNamesWithDatalayers = {
  boda: "Boda",
  casaabierta: "Open House",
  otrasceremoniasreligiosas: "Otras Ceremonias Religiosas",
  otros: "Otros",
  bautismo: "Bautizo",
  dulcesquince: "XV años",
  bebe: "Bebé",
  cumpleanos: "Cumpleaños",
  mascotas: "Mascotas"
}

export const MAX_AGE_DEVICE_ID=15552000;

export const RESTRICTED_EVENT_STATUSES = [
  eventStatus.SUSPENDED,
  eventStatus.VALIDITY_OFF_ACTIVE,
  eventStatus.TEMPORARY_CLOSED,
  eventStatus.CLOSED,
];
